(function () {
  'use strict';

  function initPackSize(section) {
    var packSize = parseInt(section.dataset.packSize, 10);
    if (!packSize || packSize < 1) return;

    var qtySwitcher = section.querySelector('product-form qty-switcher');
    if (!qtySwitcher) return;

    var qtyInput   = qtySwitcher.querySelector('input[name="quantity"]');
    var minusBtn   = qtySwitcher.querySelector('.btn-qty-minus');
    var plusBtn    = qtySwitcher.querySelector('.btn-qty-plus');
    if (!qtyInput) return;

    var priceBlock  = section.querySelector('.product-price[data-pack-size]');
    var packPriceEl = priceBlock ? priceBlock.querySelector('.pack-price-total') : null;

    var form     = qtySwitcher.closest('form');
    var variants = [];
    var variantsScript = form ? form.querySelector('script[data-product-variants]') : null;
    
    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        console.warn('Pack Size: Could not parse variants data.');
      }
    }

    var variantIdInput = form ? form.querySelector('input[name="id"]') : null;

    function formatMoney(cents) {
      var moneyFormat = (window.Shopify && window.Shopify.moneyFormat) || '\u20B9{{amount}}';
      var amount = cents / 100;
      var str;

      if (amount % 1 === 0) {
        str = amount.toFixed(0);
      } else {
        str = amount.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
      }

      var parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      str = parts.join('.');

      var noDecimals = Math.round(amount)
        .toFixed(0)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return moneyFormat
        .replace('{{amount_no_decimals}}', noDecimals)
        .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals.replace(/,/g, '.'))
        .replace('{{amount_with_comma_separator}}',
          str.replace('.', '#').replace(/,/g, '.').replace('#', ','))
        .replace('{{amount}}', str);
    }

    function getUnitPrice() {
      return priceBlock ? (parseInt(priceBlock.dataset.unitPrice, 10) || 0) : 0;
    }

    function updatePackPrice() {
      if (!packPriceEl) return;
      var unitPrice = getUnitPrice();
      var qty = parseInt(qtyInput.value, 10) || packSize;
      packPriceEl.textContent = formatMoney(unitPrice * qty);
    }

    function normalizeQty(val) {
      var qty = parseInt(val, 10);
      if (isNaN(qty) || qty < packSize) return packSize;
      return Math.ceil(qty / packSize) * packSize;
    }

    /** Enable / disable the minus button. */
    function updateMinusBtn() {
      if (!minusBtn) return;
      minusBtn.disabled = (parseInt(qtyInput.value, 10) || packSize) <= packSize;
    }

    function setQuantity(newQty) {
      var qty = normalizeQty(newQty);

      var max = qtyInput.getAttribute('max');
      if (max && max !== '') {
        var maxInt = parseInt(max, 10);
        if (qty > maxInt) {
          qty = Math.floor(maxInt / packSize) * packSize;
          if (qty < packSize) qty = packSize;
        }
      }

      qtyInput.value = qty;

      qtyInput.dispatchEvent(new Event('input',  { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

      updateMinusBtn();
      updatePackPrice();
    }

    qtyInput.value = packSize;
    qtyInput.setAttribute('min',  String(packSize));
    qtyInput.setAttribute('step', String(packSize));
    updateMinusBtn();
    updatePackPrice();

    if (plusBtn) {
      plusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var current = parseInt(qtyInput.value, 10) || packSize;
        setQuantity(current + packSize);
      }, true);
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var current = parseInt(qtyInput.value, 10) || packSize;
        if (current <= packSize) return;
        setQuantity(current - packSize);
      }, true);
    }

    var debounceTimer = null;

    qtyInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updatePackPrice, 300);
    });

    qtyInput.addEventListener('blur', function () {
      clearTimeout(debounceTimer);
      setQuantity(this.value);
    });

    qtyInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        clearTimeout(debounceTimer);
        setQuantity(this.value);
      }
    });

    function onVariantChange(variantId) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === variantId) {
          if (priceBlock) {
            priceBlock.dataset.unitPrice = variants[i].price;
            updatePackPrice();
          }
          return;
        }
      }
    }

    if (variantIdInput && variants.length > 0) {
      var attrObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'value') {
            var id = parseInt(variantIdInput.getAttribute('value'), 10);
            if (id) onVariantChange(id);
          }
        }
      });
      attrObserver.observe(variantIdInput, { attributes: true });

      var priceFinalEl = section.querySelector('.product-price-final');
      if (priceFinalEl) {
        var textObserver = new MutationObserver(function () {
          var id = parseInt(variantIdInput.value, 10);
          if (id) onVariantChange(id);
        });
        textObserver.observe(priceFinalEl, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }

  var sections = document.querySelectorAll('.product-main[data-pack-size]');
  sections.forEach(initPackSize);
})();